import React, { useEffect, useState } from "react";
import { Star, Eye, EyeOff, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Pill } from "./Primitives";
import { photoSrc } from "../pages/Stories";

export default function AdminStories() {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/admin/stories").then((r) => { setStories(r.data); setLoading(false); }).catch(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const patch = async (s, changes) => {
    try {
      await api.patch(`/admin/stories/${s.id}`, changes);
      setStories((prev) => prev.map((x) => (x.id === s.id ? { ...x, ...changes } : x)));
      toast.success("Updated");
    } catch { toast.error("Could not update"); }
  };

  if (loading) return <p className="mt-10 text-muted">Loading stories…</p>;

  return (
    <div className="mt-10" data-testid="admin-stories">
      <p className="mb-6 max-w-2xl text-muted">Feature outstanding stories on the landing page, or hide any that shouldn't be public.</p>
      {stories.length === 0 ? (
        <p className="border border-dashed border-edge p-12 text-center text-muted" data-testid="admin-stories-empty">No heritage stories submitted yet.</p>
      ) : (
        <div className="space-y-3">
          {stories.map((s) => (
            <div key={s.id} className="flex items-center gap-4 border border-edge bg-ash p-4" data-testid={`admin-story-${s.id}`}>
              {s.photo_url ? (
                <img src={photoSrc(s.photo_url)} alt="" className="h-12 w-12 flex-shrink-0 border border-edge object-cover" />
              ) : (
                <div className="h-12 w-12 flex-shrink-0 border border-edge bg-ink" />
              )}
              <div className="min-w-0 flex-1">
                <p className="truncate text-bone">{s.title}</p>
                <p className="text-xs text-muted">{s.year_label} · {s.region} · {s.author_name}</p>
              </div>
              {s.featured && <Pill tone="gold">Featured</Pill>}
              {!s.is_public && <Pill tone="blood">Hidden</Pill>}
              <button onClick={() => patch(s, { featured: !s.featured })} data-testid={`feature-story-${s.id}`}
                title={s.featured ? "Unfeature" : "Feature"} aria-label={s.featured ? "Unfeature story" : "Feature story on landing page"}
                className={`hover:text-gold ${s.featured ? "text-gold" : "text-muted"}`}>
                <Star className={`h-4 w-4 ${s.featured ? "fill-current" : ""}`} />
              </button>
              <button onClick={() => patch(s, { is_public: !s.is_public })} data-testid={`toggle-story-visibility-${s.id}`}
                title={s.is_public ? "Hide from public" : "Make public"} aria-label={s.is_public ? "Hide story from public" : "Make story public"}
                className="text-muted hover:text-bone">
                {s.is_public ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
